import React, { useState, useEffect, useCallback, useRef } from "react";
import SearchForm from "../../component/search-form";
// Importing scrollbar library
import SimpleBarReact from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { useNavigate } from "react-router-dom";
import { sanitizeInput } from "../../utils";

function UpdateActivitySideList({
  addRemoveAcitivity,
  activityResponse,
  card,
  configurationMapping,
  tableHeightRef,
  handleNavigation
}) {
  const [search, setSearch] = useState();

  const onSearchChange = useCallback(
    (value) => {
      if (value) {
        const searchArr = activityResponse.filter((activity) =>
          activity.name.toLowerCase().includes(value.toLowerCase())
        );
        setSearch(searchArr);
      } else {
        setSearch();
      }
    },
    [setSearch, activityResponse]
  );

  const [customeHeightinPx, setCustomeHeightinPx] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (tableHeightRef ?? tableHeightRef.current.clientHeight) {
      setCustomeHeightinPx(tableHeightRef.current.clientHeight);
    }
  }, [tableHeightRef?.current?.clientHeight]);
  return (
    <div className="hidden md:block sm:p-0 space-y-1 md:w-1/4">
      <h4 className="font-extrabold text-2xl sm:text-base sm:border-b sm:p-4">
        To Dos
      </h4>
      <div className="sm:p-2 space-y-1">
        <SearchForm
          placeholder="Search"
          onChange={(e) => {
            const value = sanitizeInput(e.target.value);
            onSearchChange(value);
          }}
        />
        <button
          className="btn bg-white w-full border-slate-200 hover:border-slate-300 text-slate-600 space-x-2"
          onClick={() => {
            handleNavigation()
          }}
        >
          <i class="fa-solid fa-plus"></i>
          <p className="text-sm">Add New To Do</p>
        </button>
      </div>
      <SimpleBarReact
        style={{
          maxHeight:
            customeHeightinPx > 555 ? `${customeHeightinPx + 50}px` : "555px",
          overflowY: "auto",
        }}
      >
        <div className="hidden sm:block sm:p-2 sm:space-y-2">
          {(search &&
            (search.length > 0 ? (
              search.map((element, index) => {
                return (
                  <div
                    className={
                      // activityCardList.find((item) => item.id === element.id) ||
                      configurationMapping.find(
                        (item) => item.activity.id === element.id
                      )
                        ? "bg-blue-200 h-16 flex flex-col justify-center cursor-pointer rounded"
                        : "bg-neutral-100 h-16 flex flex-col justify-center cursor-pointer rounded"
                    }
                    onClick={() => {
                      addRemoveAcitivity(element, index);
                    }}
                  >
                    <div className="flex justify-between px-6">
                      <div className="w-2/3">
                        <h1
                          title={element.name}
                          className="text-sm font-semibold leading-6 overflow-hidden whitespace-nowrap text-ellipsis"
                        >
                          {element.name}
                        </h1>
                      </div>
                    </div>
                    <div className="flex justify-between px-6">
                      <p
                        title={element.description}
                        className="text-xs leading-5 w-2/3 truncate"
                      >
                        {element.description}
                      </p>
                      {configurationMapping.find(
                        (item) => item.activity.id === element.id
                      ) ? (
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="check-circle"
                          class="w-4 h-4 mr-2 fill-current"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path
                            fill="currentColor"
                            d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                          ></path>
                        </svg>
                      ) : null}
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="text-center font-medium leading-4">
                No To Dos is found.
              </p>
            ))) ||
            (card.length > 0 ? (
              card.map((element, index) => {
                return (
                  <div
                    className={
                      // activityCardList.find((item) => item.id === element.id) ||
                      configurationMapping.find(
                        (item) => item.activity.id === element.id
                      )
                        ? "bg-blue-200 h-16 flex flex-col justify-center cursor-pointer rounded"
                        : "bg-neutral-100 h-16 flex flex-col justify-center cursor-pointer rounded"
                    }
                    onClick={() => {
                      addRemoveAcitivity(element, index);
                    }}
                  >
                    <div className="flex justify-between space-x-1 px-6 ">
                      <div className="w-2/3">
                        <h1
                          title={element.name}
                          className="text-sm font-semibold leading-6 overflow-hidden whitespace-nowrap text-ellipsis"
                        >
                          {element.name}
                        </h1>
                      </div>
                      {element.deletedAt && element.deletedAt !== null && (
                        <div
                          className={`px-2 py-1 rounded-xl text-xs font-medium w-20 text-center`}
                          style={{ background: "rgb(254, 202, 202)" }}
                        >
                          Removed
                        </div>
                      )}
                    </div>
                    <div className="flex justify-between px-6">
                      <p title={element.description} className="text-xs leading-5 w-2/3 truncate">
                        {element.description}
                      </p>
                      {configurationMapping.find(
                        (item) => item.activity.id === element.id
                      ) ? (
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="check-circle"
                          class="w-4 h-4 mr-2 fill-current"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path
                            fill="currentColor"
                            d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                          ></path>
                        </svg>
                      ) : null}
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="text-center font-medium leading-4">
                No task is found.
              </p>
            ))}
        </div>
      </SimpleBarReact>
    </div>
  );
}

export default React.memo(UpdateActivitySideList);
